
import SharedContentListContainer from 'containers/SharedContentContainer/SharedContentListContainer';

export const SharedDefaultListScreen = () => <SharedContentListContainer />;

export default SharedDefaultListScreen;
